import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

type LineChartProps = {
  series: {
    name: string;
    data: number[];
    color?: string;
  }[];
  categories: string[];
  xAxisLabelsOptionsStep?: number | undefined;
  height?: number;
  title?: string;
  yAxisTitle?: string;
  xAxisTitle?: string;
  labelsFontSize?: string;
  subtitle?: string;
};

const LineChart: React.FC<LineChartProps> = ({
  series,
  categories,
  height,
  title,
  subtitle,
  xAxisLabelsOptionsStep,
  labelsFontSize,
  xAxisTitle,
  yAxisTitle,
}) => {
  const options: Highcharts.Options = {
    title: { text: title },
    chart: {
      type: "line",
      height: height,
    },
    exporting: { enabled: false },
    subtitle: subtitle ? { text: subtitle } : undefined,
    xAxis: {
      categories,
      title: xAxisTitle ? { text: xAxisTitle } : undefined,
      labels: {
        step: xAxisLabelsOptionsStep,
        style: {
          fontSize: labelsFontSize,
        },
      },
    },
    yAxis: {
      title: yAxisTitle ? { text: yAxisTitle } : undefined,
      labels: {
        style: {
          direction: "ltr",
        },
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
          style: {
            direction: "ltr",
          },
        },
      },
    },
    tooltip: {
      style: {
        direction: "ltr",
      },
      formatter: function () {
        return `${this.series.name}: ${this.y}`;
      },
    },
    series: series.map((s) => ({
      type: "line",
      name: s.name,
      data: s.data,
      color: s.color,
    })),
    credits: { enabled: false },
  };

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={{ style: { width: "100%" } }}
    />
  );
};

export default LineChart;
